
import { Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { NO_INFORMATION } from "@/data/placeholders";
import ToggleFavorite from "@/components/favorite/ToggleFavoriteRequests.vue";
import ToggleDNUFlag from "@/components/contractors/ToggleDNUFlag.vue";
import Get_Contractor_Details from "@/apollo/contractors/GetContractorDetailsNew.gql";
import GET_CONTRACTOR_BASIC_INFO from "@/apollo/contractors/GetContractorBasicInfo.gql";
import DELETE_CONTRACTOR_FROM_MANAGER_DB from "@/apollo/contractors/DeleteContractorFromManagerDB.gql";
import TabNotificationBubble from "@/components/common/TabNotificationBubbleNew.vue";
import GET_IS_MANAGER_CONTRACTOR from "@/apollo/profile/IsContractorCreator.gql";
import PageInfo from "@/components/page/PageInfo.vue";
import GetRelativeRouteNameMixin from "@/mixins/route/GetRelativeRouteNameMixin.vue";
import ResumeSidebar from "@/components/contractors/ResumeSidebar.vue";
import ContractorHeader from "@/components/contractors/ContractorHeaderNew.vue";
import TabsWithRoutes from "@/components/common/TabsWithRoutesNew.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import CardRating from "@/components/rating/CardRating.vue";
import MessageIcon from "@/components/icons/ChatIconNew.vue";
import MessageIconHover from "@/components/icons/ChatIconHoverNew.vue";
import ItemChipsData from "@/entities/ItemChipsData";
import DeleteIcon from "@/components/icons/DeleteIcon.vue";
import DeleteIconHover from "@/components/icons/DeleteIconHover.vue";
import EditIcon from "@/components/icons/Pencil-Icon.vue";
import EditIconHover from "@/components/icons/Pencil-Icon-Hover.vue";
import GET_PROFILE_DETAILS_BY_MANAGEMENT_ALL from "@/apollo/profile/profileDetails/management/GetProfileDetailByManagementAll.gql";
import UPDATE_ARCHIVE from "@/apollo/user/UpdateUserArchived.gql";
import TrashIcon from "@/components/icons/TrashIcon.vue";
import UIButton from "@/components/button/ui-button.vue";
import StarRating from "vue-star-rating";
import NavGrayArrow from "@/components/icons//NavGrayArrow.vue";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
import EmailSecondaryIcon from "@/components/icons/EmailSecondaryIcon.vue";
import NotificationOffIcon from "@/components/icons/NotificationOffIcon.vue";
import PlusIcon from "@/components/icons/PlusIcon.vue";
import ContractorResendInvitation from "@/components/invite/ContractorResendInvitationCustom.vue";
import InvitationSentTooltip from "@/components/invite/InvitationSentTooltip.vue";
import CustomSwitch from "@/components/common/CustomSwitch.vue";
import ViewIconBlack from "@/components/icons/ViewIconBlack.vue";
import ViewIcon from "@/components/icons/ViewIcon.vue";
import ManagementAddContractorInfo from "@/components/contractors/ManagementAddContractorInfoNew.vue";
import RouteNames from "@/entities/RouteNames";
import RoutesNames from "@/entities/RouteTabs";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import {
  User,
  Contractor,
  Company,
  Tag,
  User_Profile_By_Management,
} from "@/generated/graphql";
import GET_CONTRACTOR_RATINGS from "@/apollo/contractors/GetContractorRatings.gql";
import CopyLink from "@/components/icons/CopyLinkGray.vue";
import CopyLinkHover from "@/components/icons/CopyLinkHover.vue";
import Tooltip from "@/components/common/Tooltip.vue";
import TooltipVariants from "@/entities/TooltipVariants";
import Badge from "@/components/common/BadgeNew.vue";
import HoveredIcon from "@/components/icons/HoveredIcon.vue";
import MailTo from "@/components/common/MailTo.vue";
import PhoneTo from "@/components/common/PhoneTo.vue";
import ReviewSidebar from "@/components/contractors/ReviewSidebar.vue";
import { emailStatusText, inviteNotSent } from "@/data/userStatuses";
import BadgeColor from "@/entities/BadgeColor";
import EmployeeTag from "@/components/employee/EmployeeTagNew.vue";
import getInitials from "@/helpers/getInitials";
import RemoveFromCompanyModal from "@/components/contractors/RemoveFromCompanyModal.vue";
import PageHeadIcon from "@/components/page/PageHeadIconNew.vue";
import CrowdIcon from "@/components/icons/CrowdIcon.vue";
import Added_by from "@/apollo/managers/GetAddedByManager.gql";
import FormToggle from "@/components/form/FormToggle.vue";
import TOGGLE_IS_PUBLIC from "@/apollo/profile/ToggleIsPublic.gql";
import LIST_DOCUMENTS from "@/apollo/documents/ListDocuments.gql";
import getAuthData from "@/utils/getAuthData";
import { Project } from "@/generated/graphql";
import paginationConfig from "@/data/paginationConfig";
import LIST_PROJECTS from "@/apollo/projects/ListProjects.gql";
import { MessageDuration } from "@/data/notificationsMessages";
import DotIcon from "@/components/icons/DotIcon.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import { sendPendingInvites } from "@/services/inviteContractorsPeding";
import GET_VISITS_BY_CONTRACTOR from "@/apollo/contractors/GetContractorVisits.gql";
import PencilIcon from "@/components/icons/EditIcon.vue";
interface ContractorDetails {
  contractor_by_pk: Contractor;
  activeProjectsCount: number;
  completedProjectsCount: number;
  totalHoursTracked: number;
}
interface RatingQueryVariables {
  contractorId: string;
  currentUserId: string;
}

interface ManagementAddedInfoMode {
  phone: boolean;
  email: boolean;
  website: boolean;
  country: boolean;
  region: boolean;
  city: boolean;
  postalCode: boolean;
  rate: boolean;
  jobTitle: boolean;
}

interface ManagementAddedInfoModeRate {
  rate: boolean;
}

@Component({
  components: {
    "custom-switch": CustomSwitch,
    EmployeeTag,
    StarRating,
    ViewIconBlack,
    EditIcon,
    CopyLink,
    Tooltip,
    CopyLinkHover,
    TooltipVariants,
    EditIconHover,
    MailTo,
    PhoneTo,
    MessageIcon,
    MessageIconHover,
    ViewIcon,
    HoveredIcon,
    NavGrayArrow,
    Badge,
    CardRating,
    ResumeSidebar,
    ReviewSidebar,
    ContractorResendInvitation,
    ManagementAddContractorInfo,
    ContractorHeader,
    TabsWithRoutes,
    LoadingOverlay,
    TabNotificationBubble,
    TrashIcon,
    UIButton,
    EmailSecondaryIcon,
    PageHeadIcon,
    ToggleFavorite,
    ToggleDNUFlag,
    UiButtonMessage,
    DeleteIcon,
    DeleteIconHover,
    CrowdIcon,
    NotificationOffIcon,
    PlusIcon,
    PageInfo,
    DotIcon,
    RemoveFromCompanyModal,
    InvitationSentTooltip,
    FormToggle,
  },
  apollo: {
    managerContractor: {
      query: GET_IS_MANAGER_CONTRACTOR,
      variables() {
        return {
          userId: this.currentUser?.id,
          contractorId: this.contractorId,
        };
      },
      update(data) {
        this.managersTotal = data.manager_contractor;
        return data.manager_contractor;
      },
    },
    contractor: {
      query: GET_CONTRACTOR_BASIC_INFO,
      variables() {
        return {
          id: this.contractorId,
          userId: this.currentUser.id,
          companyId: this.company?.id,
        };
      },
      update(data) {
        this.resId = data.contractor_by_pk.user.id;
        this.$apollo.queries.contractorDetails.skip = false;
        //visit count
        return data.contractor_by_pk;
      },
      skip() {
        return !this.company.id;
      },
    },
    profilesByManagement: {
      query: GET_PROFILE_DETAILS_BY_MANAGEMENT_ALL,
      variables() {
        return {
          userId: this.contractor?.user.id,
        };
      },
      update(data) {
        return data.user_profile_by_management;
      },
    },
    contractorDetails: {
      query: Get_Contractor_Details,
      variables() {
        return this.queryArgs;
      },
      update(data) {
        this.addedById = data.contractor_by_pk.user.created_by;
        this.projectsTotal = data.projectsCount.aggregate.count;
        // this.reviewsTotal = data.documetsCount.aggregate.count;
        this.managersTotal = data.managersCount.aggregate.count;
        this.notesTotal = data.notesCount.aggregate.count;
        this.contractorDetail = data;

        return {
          contractor: data.contractor_by_pk,
          activeProjectsCount: data.active.aggregate.count,
          completedProjectsCount: data.completed.aggregate.count,
          totalHoursTracked:
            data.project_activity_time_aggregate.aggregate.sum.time,
        };
      },
      skip() {
        return true;
      },
    },
    ratings: {
      query: GET_CONTRACTOR_RATINGS,
      variables() {
        return this.ratingQueryVariables;
      },
      update(data) {
        this.paginationConfig.loadedCount = data.contractorRatings.length;
        this.paginationConfig.total = data.ratingTotal.aggregate.count;
        this.reviewsTotal = data.ratingTotal.aggregate.count;
        this.myReview = data.myReview?.[0];
        this.ratingTotal = data.ratingTotal;
        return data.contractorRatings;
      },
    },
    projects: {
      query: LIST_PROJECTS,
      variables() {
        return this.contractorProjectsArgs;
      },
      update(data) {
        return data.project;
      },
    },
    documents: {
      query: LIST_DOCUMENTS,
      variables() {
        return this.contractorDocumentArgs;
      },
      update(data) {
        this.doumentsTotal = data.total.aggregate.count;
        return data.document;
      },
    },
    visits: {
      query: GET_VISITS_BY_CONTRACTOR,
      variables() {
        return {
          contractorId: `${this.contractorId}`,
        };
      },
      update(data) {
        this.visitsTotal = data.total.aggregate.count;
        return data.visits;
      },
    },
  },
})
export default class ContractorPage extends mixins(GetRelativeRouteNameMixin) {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: Object, required: true })
  BadgeColor: typeof BadgeColor = BadgeColor;

  emailStatusText: string = emailStatusText;
  TooltipVariants = TooltipVariants;
  inviteNotSent: string = inviteNotSent;
  profilesByManagement: User_Profile_By_Management[] = [];
  processing: boolean = false;
  projectsTotal: number = 0;
  visitsTotal: number = 0;
  doumentsTotal: number = 0;
  reviewsTotal: number = 0;
  fullname: String = "";
  managersTotal: number = 0;
  notesTotal: number = 0;
  contUserId: string = "";
  resId: number | string = 0;
  contractor?: any = [];
  contractorDetail?: ContractorDetails;
  routes: typeof RouteNames = RouteNames;
  managerContractor?: any = [];
  addedById: Number = 0;
  projects?: Project[] = undefined;
  activeProjectsCount: any = localStorage.getItem("activeProjectsCount");
  completedProjectsCount: any = localStorage.getItem("completedProjectsCount");
  showManagementAddContractorInfoModal: boolean = false;
  removeFromCompanyModalShown: boolean = false;
  paginationConfig: PaginationConfig = { ...paginationConfig };
  ratingTotal: any = {};
  isHoveredChat: boolean = false;
  isHoveredCopy: boolean = false;
  isHoveredDelete: boolean = false;
  isHoveredEdit: boolean = false;
  isHoveredEditRate: boolean = false;
  isHoveredEditJobTitle: boolean = false;
  managementAddedInfoMode: ManagementAddedInfoMode = {
    email: false,
    phone: false,
    website: false,
    country: false,
    region: false,
    city: false,
    postalCode: false,
    rate: false,
    jobTitle: false,
  };
  managementAddedInfoModeInit: ManagementAddedInfoMode = {
    email: false,
    phone: false,
    website: false,
    country: false,
    region: false,
    city: false,
    postalCode: false,
    rate: false,
    jobTitle: false,
  };
  managementAddedInfoModeRate: ManagementAddedInfoModeRate = {
    rate: false,
  };

  @Watch("resId", { immediate: true })
  onResIdChange(newVal: any, oldVal: any) {
    if (newVal) {
      this.$apollo.queries.documents.refetch();
      this.$apollo.queries.contractorDetails.refetch();
      this.$apollo.queries.profilesByManagement.refetch();
    }
  }

  get contractorId(): string {
    return this.$route.params.id;
  }

  get contractorPageRoute() {
    return {
      name: RouteNames.COMPANY_DATABASE,
    };
  }

  get contractorDocumentArgs(): Object {
    return {
      where: {
        filename: { _ilike: "%%" },
        _and: [
          {
            uploaded_by: {
              _eq: this.currentUser.id,
            },
          },
          {
            attached_to: {
              user_id: {
                _eq: this.resId,
              },
            },
          },
        ],
      },
    };
  }

  updateCrumb() {
    const breadcrubmData = document.querySelector(
      ".contractor_detail_crubm_li > span"
    );
    if (breadcrubmData) {
      breadcrubmData.innerHTML = `${this.contractorFullName}`;
    }
  }
  @Watch("contractor")
  crumbdata() {
    this.updateCrumb();
  }
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange() {
    this.updateCrumb();
  }

  get fullName() {
    return this.fullname;
  }

  get maxAvailableHours(): number | null {
    if (
      this.contractorDetail &&
      this.contractorDetail.contractor_by_pk &&
      this.contractorDetail.contractor_by_pk.user &&
      this.contractorDetail.contractor_by_pk.user.profile &&
      this.contractorDetail.contractor_by_pk.user.profile.max_available_hours
    ) {
      return this.contractorDetail.contractor_by_pk.user.profile
        .max_available_hours;
    }
    return null;
  }

  get isDNUFlagged(): boolean {
    // Try detailed contractor data first
    if (
      this.contractorDetail &&
      this.contractorDetail.contractor_by_pk &&
      this.contractorDetail.contractor_by_pk.user &&
      this.contractorDetail.contractor_by_pk.user.profile &&
      this.contractorDetail.contractor_by_pk.user.profile.DNU_flag !== undefined
    ) {
      return Boolean(
        this.contractorDetail.contractor_by_pk.user.profile.DNU_flag
      );
    }

    // Try basic contractor data as fallback
    if (
      this.contractor &&
      this.contractor.user &&
      this.contractor.user.profile &&
      this.contractor.user.profile.DNU_flag !== undefined
    ) {
      return Boolean(this.contractor.user.profile.DNU_flag);
    }

    return false;
  }

  refreshContractorData(): void {
    // Force network-only refetch to bypass cache completely
    this.$apollo.queries.contractor.refetch();
    this.$apollo.queries.contractorDetails.refetch().then(() => {
      // Additional refetch with a small delay to ensure consistency
      setTimeout(() => {
        this.$apollo.queries.contractorDetails.refetch();
      }, 100);
    });
  }

  get emailByManagement(): ItemChipsData[] {
    if (!this.profilesByManagement.length) {
      return [];
    }
    var emails = [];
    this.profilesByManagement.forEach((profile) => {
      if (profile.email) {
        emails.push({ id: this.contractorId, name: profile.email });
      }
    });
    return emails;
  }

  get phoneByManagement(): ItemChipsData[] {
    if (!this.profilesByManagement.length) {
      return [];
    }
    var phones = [];
    this.profilesByManagement.forEach((profile) => {
      if (profile.phone) {
        phones.push({ id: this.contractorId, name: profile.phone });
      }
    });
    return phones;
  }

  get locationByManagement(): ItemChipsData[] {
    if (!this.profilesByManagement.length) {
      return [];
    }

    const location = [];

    this.profilesByManagement.forEach((profile) => {
      const city = typeof profile.city === "string" ? profile.city.trim() : "";
      const state =
        typeof profile.state === "string" ? profile.state.trim() : "";
      const country =
        typeof profile.country === "string" ? profile.country.trim() : "";
      const address =
        typeof profile.address === "string" ? profile.address.trim() : "";

      if (city || state || country) {
        location.push({
          id: this.contractorId,
          city: city || null,
          state: state || null,
          country: country || null,
          address: address || null,
        });
      }
    });

    return location;
  }

  get dashboardRoute() {
    return {
      name: RouteNames.DASHBOARD,
    };
  }

  get ratingQueryVariables(): RatingQueryVariables {
    return {
      contractorId: this.contractorId,
      currentUserId: this.currentUser.id,
    };
  }

  get itemContarctorCountWhere() {
    return { contractor_id: { _eq: this.contractorId } };
  }

  get itemUserCountWhere() {
    return { user_id: { _eq: this.currentUser.id } };
  }

  calculateAverageRating() {
    if (this.ratingTotal && this.ratingTotal.aggregate.count > 0) {
      const averageRating =
        this.ratingTotal.aggregate.sum.score / this.ratingTotal.aggregate.count;
      return averageRating;
    } else {
      return 0;
    }
  }

  async handleCopy(res) {
    try {
      await navigator.clipboard.writeText(
        `${window.location.origin}/company_database/contractors/${res}/about`
      );
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(`Profile link copied to clipboard!`)
      );
    } catch (err) {}
  }

  calculateTotal() {
    if (this.ratingTotal && this.ratingTotal.aggregate.count > 0) {
      return this.ratingTotal.aggregate.count;
    } else {
      return;
    }
  }

  @Watch("addedById")
  handler(newValue) {
    if (newValue !== null) {
      this.fetchAddedBy(newValue);
    }
  }

  async fetchAddedBy(newValue) {
    try {
      if (newValue !== null) {
        const { data } = await this.$apollo.query({
          query: Added_by,
          variables: {
            id: this.addedById,
          },
        });
        this.fullname = `${data.user?.[0]?.given_name} ${data.user?.[0]?.family_name}`;
      } else {
        return "n/a";
      }
    } catch (error) {
      return "";
    }
  }

  async sendInvitation(conId) {
    try {
      const contrcId = [conId];
      const invitedContractorsIds = await sendPendingInvites({
        contractorIds: contrcId,
      });
      const successMessage = "Invited";
      const duration = MessageDuration.DEFAULT;
      this.$eventBus.emit(NOTIFICATION, Message.successMessage("Invite sent"));
      window.location.reload();
    } catch (error) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(error.message));
    }
  }

  get createdDate(): String {
    if (
      this.contractorDetail.contractor_by_pk.created_at &&
      this.contractorDetail.contractor_by_pk.created_at !== null
    ) {
      const joinedDate = new Date(
        this.contractorDetail.contractor_by_pk.created_at
      );
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const year = joinedDate.getFullYear();
      const month = joinedDate.getMonth();

      const formattedDate = `${monthNames[month]} ${year}`;

      return formattedDate;
    }
    return;
  }

  get initials() {
    const { given_name: givenName, family_name: familyName } =
      this.contractor!.user!;
    return getInitials(givenName!, familyName!);
  }

  get appliedTag(): Tag | undefined {
    return this.contractor?.tag || undefined;
  }

  get queryArgs(): Object {
    return {
      id: this.contractorId,
      adminId: this.currentUser.id,
      userId: this.resId,
      activeWhere: {
        project_activities: {
          _and: [
            {
              completed: { _eq: false },
              drafted: { _eq: false },
            },
            {
              contractor: {
                user_id: {
                  _eq: this.contractorId,
                },
              },
            },
          ],
        },
      },
      completedWhere: {
        completed: { _eq: true },
        drafted: { _eq: false },
        project_activities: {
          _and: [
            {
              contractor: {
                user_id: { _eq: this.contractorId },
              },
            },
          ],
        },
      },
    };
  }

  get contractorProjectsArgs(): any {
    const queryTemplate = {
      offset: null,
      // limit: null,
      where: {},
    };

    const generalCondition = {
      project_activities: {
        contractor: {
          user_id: {
            _eq: this.resId,
          },
        },
      },
    };

    if (this.currentUser.role === "MANAGER") {
      queryTemplate.where = {
        _and: [
          generalCondition,
          {
            project_activities: {
              project: {
                manager: {
                  user_id: {
                    _eq: this.currentUser.id,
                  },
                },
              },
            },
          },
        ],
      };

      return queryTemplate;
    }

    queryTemplate.where = {
      _and: [
        generalCondition,
        {
          company: {
            admins: {
              user_id: {
                _eq: this.currentUser.id,
              },
            },
          },
        },
      ],
    };

    return queryTemplate;
  }

  get showProject(): boolean {
    return this.projectsTotal > 0;
  }

  get showVisits(): boolean {
    return this.visitsTotal > 0;
  }

  get showReview(): boolean {
    return this.reviewsTotal > 0;
  }

  get location(): string {
    const { country, state, city, address } = this.contractor.user.profile;
    const location = [address, city, state, country]
      .filter((place) => Boolean(place))
      .join(", ");
    return location.length > 0 ? location : null;
  }

  get getOccupation(): String | null {
    // First check if user_job_title is available (using type assertion for new GraphQL field)
    const profile = this.contractorDetail?.contractor_by_pk?.user
      ?.profile as any;
    if (profile?.user_job_title?.job_title) {
      return profile.user_job_title.job_title;
    }

    // Fallback to legacy job_title field
    if (profile?.job_title) {
      return profile.job_title;
    }

    // Final fallback to first experience job title
    if (this.contractorDetail?.contractor_by_pk?.user?.experiences?.[0]) {
      return this.contractorDetail.contractor_by_pk.user.experiences[0]
        .job_title;
    }

    return null;
  }

  get getCompany(): String | null {
    if (
      this.contractorDetail &&
      this.contractorDetail.contractor_by_pk &&
      this.contractorDetail.contractor_by_pk.user &&
      this.contractorDetail.contractor_by_pk.user.profile?.company_name
    ) {
      return this.contractorDetail.contractor_by_pk.user.profile?.company_name;
    } else if (
      this.contractorDetail.contractor_by_pk.user?.experiences?.[0]
        ?.company_name
    ) {
      return this.contractorDetail.contractor_by_pk.user?.experiences?.[0]
        ?.company_name;
    } else {
      return;
    }
  }

  get website(): String | null {
    if (
      this.contractorDetail &&
      this.contractorDetail.contractor_by_pk &&
      this.contractorDetail.contractor_by_pk.user
    ) {
      if (this.contractorDetail.contractor_by_pk.user.profile) {
        return (
          this.contractorDetail.contractor_by_pk.user.profile.website &&
          this.contractorDetail.contractor_by_pk.user.profile.website
        );
      }
    }
    return null;
  }

  get phoneNumber(): Number | String | null {
    if (
      this.contractorDetail &&
      this.contractorDetail.contractor_by_pk &&
      this.contractorDetail.contractor_by_pk.user
    ) {
      return this.contractorDetail.contractor_by_pk.user.private_data.phone;
    }
    return null;
  }

  get contractorRates(): string | undefined {
    if (
      this.contractorDetail &&
      this.contractorDetail.contractor_by_pk &&
      this.contractorDetail.contractor_by_pk.user
    ) {
      const minRate =
        this.contractorDetail.contractor_by_pk.user.profile.min_rate ||
        this.contractorDetail.contractor_by_pk.user
          .user_profile_by_managements?.[0]?.min_rate;
      const maxRate =
        this.contractorDetail.contractor_by_pk.user.profile.max_rate ||
        this.contractorDetail.contractor_by_pk.user
          .user_profile_by_managements?.[0]?.max_rate;
      const currency =
        this.contractorDetail.contractor_by_pk.user.profile.currency ||
        this.contractorDetail.contractor_by_pk.user
          .user_profile_by_managements?.[0]?.currency;
      const rateUnit =
        this.contractorDetail.contractor_by_pk.user.profile.rate_unit ||
        this.contractorDetail.contractor_by_pk.user
          .user_profile_by_managements?.[0]?.rate_unit;
      if (!minRate && !maxRate) {
        return;
      }

      if (!maxRate) {
        return `$${minRate} ${currency}/${rateUnit}`;
      }

      if (!minRate) {
        return `$${maxRate} ${currency}/${rateUnit}`;
      }

      return `$${minRate}-$${maxRate} ${currency}/${rateUnit}`;
    }
    return "";
  }

  get getJobType(): String {
    if (this.contractor.tag && this.contractor.tag !== null) {
      return this.contractor.tag.name;
    } else {
      return null;
    }
  }

  isEmailUnconfirmed(): boolean {
    if (
      this.contractorDetail &&
      this.contractorDetail.contractor_by_pk &&
      this.contractorDetail.contractor_by_pk.user
    ) {
      return !Boolean(this.contractorDetail.contractor_by_pk.user.confirmed);
    }
  }

  isPendingInvite(): boolean {
    if (
      this.contractorDetail &&
      this.contractorDetail.contractor_by_pk &&
      this.contractorDetail.contractor_by_pk.user
    ) {
      return Boolean(
        this.contractorDetail.contractor_by_pk.user.pending_invite
      );
    }
  }

  get isContractorDeleted(): boolean {
    return this.contractor?.user.archived;
  }

  get contractorId_(): Object {
    return {
      contractor_id: this.contractorId,
    };
  }

  get removeButtonText(): string {
    return this.isManagerRole ? "Revoke Access" : "Remove from company";
  }

  get isManagerRole(): boolean {
    return this.currentUser.role === "MANAGER";
  }

  get isAdminRole(): boolean {
    return this.currentUser.role === "ADMIN";
  }

  get managerId(): string | undefined {
    if (this.currentUser.role === "MANAGER") {
      return this.currentUser.manager!.id;
    }
    return undefined;
  }

  get routeTabsManager(): RoutesNames {
    const tabs = {
      [RouteNames.CONTRACTOR_DETAILS_ABOUT]: "about",
      [RouteNames.CONTRACTOR_DETAILS_VISITS]: "visits",
      [RouteNames.CONTRACTOR_DETAILS_PROJECTS]: "clients",
      [RouteNames.CONTRACTOR_DETAILS_NOTES]: "notes",
      [RouteNames.CONTRACTOR_DETAILS_DOCUMENTS]: "documents",
      [RouteNames.CONTRACTOR_DETAILS_REVIEWS]: "reviews",
      [RouteNames.CONTRACTOR_DETAILS_INFO]: "AdditionalInfo",
    };
    return {
      ...tabs,
    };
  }

  get routeTabsAdmin(): RoutesNames {
    const tabs = {
      [RouteNames.CONTRACTOR_DETAILS_ABOUT]: "about",
      [RouteNames.CONTRACTOR_DETAILS_PROJECTS]: "clients",
      [RouteNames.CONTRACTOR_DETAILS_VISITS]: "visits",
      [RouteNames.CONTRACTOR_DETAILS_MANAGERS]: "managers",
      [RouteNames.CONTRACTOR_DETAILS_NOTES]: "notes",
      [RouteNames.CONTRACTOR_DETAILS_DOCUMENTS]: "documents",
      [RouteNames.CONTRACTOR_DETAILS_REVIEWS]: "reviews",
      [RouteNames.CONTRACTOR_DETAILS_INFO]: "AdditionalInfo",
    };
    return {
      ...tabs,
    };
  }

  get permissionDenied(): boolean {
    return !this.contractor?.user?.private_data?.email;
  }

  get isContractorExists(): boolean {
    return Boolean(this.contractor);
  }

  get contractorFullName(): string {
    if (!this.contractor) {
      return "";
    }

    const firstName = this.contractor.user.given_name;
    const lastName = this.contractor.user.family_name;
    return `${firstName} ${lastName}`;
  }

  get isDisableNotificationsIconShown(): boolean {
    return this.isAdminRole && this.isNotificationsDisabled;
  }

  get isNotificationsDisabled(): boolean {
    return this.contractor!.user.company_notifications.length > 0;
  }

  closeRemoveFromCompanyModal(): void {
    this.removeFromCompanyModalShown = false;
  }

  message(): void {
    this.$router.push({
      name: "inbox",
      query: {
        recipientUserId: this.contractor?.user?.id,
      },
    });
  }

  removeContractor(): void {
    if (this.isManagerRole) {
      this.$confirm({
        title: this.removeButtonText,
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm) => {
          if (confirm) {
            await this.removeContractorFromManagerDB();
          }
        },
      });
      return;
    }

    if (this.isAdminRole) {
      this.removeFromCompanyModalShown = true;
      return;
    }
  }

  deleteContractor(): void {
    this.$confirm({
      title: "Delete Contractor",
      message: `Are you sure?`,
      button: {
        no: "No",
        yes: "Yes",
      },
      callback: async (confirm) => {
        if (confirm) {
          await this.deleteContractorFromDB();
          // await this._deleteCognitoUserPool();
        }
      },
    });
    return;
  }

  private async archiveContractor() {
    if (this.contractor) {
      try {
        const response = await this.$apollo.mutate({
          mutation: UPDATE_ARCHIVE,
          variables: {
            user_id: this.contractor.user.id,
            archived: true,
          },
        });
      } catch (e) {
        this.$eventBus.emit(NOTIFICATION, Message.successMessage(e.message));
      } finally {
        this.processing = false;
      }
    }
  }

  async removeContractorFromManagerDB(): Promise<void> {
    this.processing = true;

    try {
      await this.removeAccessToContractor();

      this.redirectToCompatyContractorsDB();
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(
          `${this.contractorFullName} was removed from your database`
        )
      );
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.successMessage(e.message));
    } finally {
      this.processing = false;
    }
  }

  async _deleteCognitoUserPool() {
    try {
      const uri = `${process.env.VUE_APP_LAMBDA}/delete-cognito-user`;
      const { headers } = await getAuthData();
      const { data }: any = await this.axios.post(
        uri,
        {
          data: {
            username: this.contractor?.user?.id,
          },
        },
        { headers }
      );
      return data.valid;
    } catch (error) {
      return false;
    } finally {
    }
  }
  get completedProjects() {
    return this.projects?.filter((project) => project.completed).length;
  }
  get activeProjects() {
    return this.projects?.filter(
      (project) => !project.completed && !project.drafted
    ).length;
  }
  async deleteContractorFromDB(): Promise<void> {
    this.processing = true;

    try {
      // await this.removeContractorRevoke();

      await this.archiveContractor();
      this.redirectToCompatyContractorsDB();
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(`${this.contractorFullName} was deleted.`)
      );
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.successMessage(e.message));
    } finally {
      this.processing = false;
    }
  }

  redirectToCompatyContractorsDB(): void {
    this.$router.push({
      name: RouteNames.COMPANY_DATABASE,
    });
  }

  get iconClasses(): string {
    return "mr-1 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500";
  }

  get isContractorCreator(): boolean {
    if (
      this.isAdminRole ||
      (this.isManagerRole &&
        this.managerContractor?.[0]?.created_by === this.currentUser?.id)
    ) {
      return true;
    }
    return false;
  }

  async toggleIsPublic(): Promise<void> {
    if (!this.contractor) {
      return;
    }

    try {
      await this.$apollo.mutate({
        mutation: TOGGLE_IS_PUBLIC,
        variables: {
          userId: this.contractor?.user?.id,
          _set: { is_public: !this.contractor?.user?.is_public },
        },
      });

      const message = !this.contractor.user.is_public
        ? "This contractor is not public to all managers in company"
        : "This contractor is public to all managers in company";

      this.$eventBus.emit(NOTIFICATION, Message.successMessage(message));
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
    }
  }

  async addContractorToCompany() {
    this.processing = true;

    try {
      const response = await this.$apollo.mutate({
        mutation: UPDATE_ARCHIVE,
        variables: {
          user_id: this.contractor.user.id,
          archived: false,
        },
      });
      // this.isContractorDeleted = false;
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(
          `${this.contractorFullName} was added to company.`
        )
      );
      this.$apollo.queries.contractor.refetch();
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
    } finally {
      this.processing = false;
    }
  }
  get websitesByManagement(): ItemChipsData[] {
    if (this.profilesByManagement.length === 0) {
      return null;
    }
    var websites = [];
    this.profilesByManagement.forEach((profile) => {
      if (profile.website) {
        websites.push({ id: this.contractorId, name: profile.website });
      }
    });
    return websites.length > 0 ? websites : null;
  }

  private removeAccessToContractor() {
    if (this.contractor) {
      return this.$apollo.mutate({
        mutation: DELETE_CONTRACTOR_FROM_MANAGER_DB,
        variables: {
          where: {
            _and: [
              {
                contractor_id: { _eq: this.contractor?.id },
              },
              {
                manager_id: { _eq: this.managerId },
              },
            ],
          },
        },
      });
    }
  }

  get areAllObjectsWithIdLoaded(): boolean {
    if (
      this.currentUser &&
      this.company &&
      this.contractor &&
      this.contractor.user
    ) {
      return true;
    }
    return false;
  }

  // @Watch('managerContractor')
  // ifManagerHasAccess(): void {
  // 	if (
  // 		!this.isAdminRole &&
  // 		this.managerContractor &&
  // 		!this.managerContractor[0]?.approved
  // 	) {
  // 		// this.$router.push({
  // 		//   name: RouteNames.CONTRACTOR_PUBLIC_PAGE,
  // 		//   params: {
  // 		//     id: this.contractor.user.id,
  // 		//   },
  // 		// });
  // 		this.$router.push('/company_database/' + this.contractor.user.id);
  // 	}
  // }
}
